module.exports = __webpack_public_path__ + "img/App Notification - 36px.57eeb5ed.svg";